

























































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { DrawOptions } from "../../../interfaces/drawOptions";
@Component
export default class ColorDialog extends Vue {
    @Prop() dialogActive!: boolean;
    public drawOptions: DrawOptions = { color: "#000000FF", thickness: 1 };
    // for the slider in the color picker

    public get swatches() {
        return [
            ["#FF0000FF"],
            ["#FFF500FF"],
            ["#00FF2CFF"],
            ["#006FFFFF"],
            ["#FF00FDFF"],
            ["#000000FF"],
        ];
    }

    public colorUpdate(color: { hexa: string }) {
        this.drawOptions.color = color.hexa;
    }
    public get showDialog(): boolean {
        return this.dialogActive;
    }
    public set showDialog(e: boolean) {
        this.done();
    }

    @Emit() done() {
        return this.drawOptions;
    }
}
